/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import { RadioButtonWithLabel } from "ui/RadioButtonWithLabel";

import { ResaleApplicationCreditCardInputs } from "./ResaleApplicationCreditCardInputs";

import type { FC } from "react";

type CreditCard = {
  brand: string;
  expirationDate: string;
  lastFourDigits: string;
};

export const ResaleApplicationPaymentMethod: FC<{
  creditCard: CreditCard;
  isRegisteredCreditCardSelected: boolean;
  setIsRegisteredCreditCardSelected: (isSelected: boolean) => void;
}> = ({
  creditCard,
  isRegisteredCreditCardSelected,
  setIsRegisteredCreditCardSelected,
}) => {
  const { t } = useI18n();
  const classes = styles();

  const handleRegisteredCreditCardChange = () => {
    setIsRegisteredCreditCardSelected(true);
  };
  const handleNewCreditCardChange = () => {
    setIsRegisteredCreditCardSelected(false);
  };

  return (
    <div css={classes.root}>
      <fieldset css={classes.paymentMethodOptions}>
        <legend css={classes.visuallyHidden}>
          {t("event.resale.entry.confirmation.paymentMethodTitle")}
        </legend>

        <RadioButtonWithLabel
          checked={isRegisteredCreditCardSelected}
          description={`${creditCard.brand} •••• ${creditCard.lastFourDigits} ${t(
            "event.resale.entry.confirmation.creditCardExpiration",
            {
              expirationDate: creditCard.expirationDate,
            }
          )}`}
          label={t("event.resale.entry.confirmation.registeredCreditCard")}
          name="resalePaymentMethod"
          value="registered"
          onChange={handleRegisteredCreditCardChange}
        />

        <RadioButtonWithLabel
          checked={!isRegisteredCreditCardSelected}
          label={t("event.resale.entry.confirmation.newCreditCard")}
          name="resalePaymentMethod"
          value="new"
          onChange={handleNewCreditCardChange}
        />
      </fieldset>

      {isRegisteredCreditCardSelected ? null : (
        <ResaleApplicationCreditCardInputs />
      )}
    </div>
  );
};

const styles = () => ({
  root: css`
    display: grid;
    gap: 16px;
  `,
  paymentMethodOptions: css`
    display: grid;
    gap: 16px;
    padding: 0;
    margin: 0;
    border: 0;
  `,
  visuallyHidden: css`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  `,
});
